import { Link, NavLink } from "react-router-dom";
import { Leaf, Scissors } from "lucide-react";

const ZORYVEN_LINKS = [
  { href: "#why-zoryven", label: "Our Story" },
  { href: "#range", label: "Products" },
  { href: "#usage-guide", label: "How to Use" },
  { href: "#reviews", label: "Reviews" },
  { href: "#contact", label: "Enquire" },
];

const SALOON_LINKS = [
  { href: "#services-grid", label: "Services" },
  { href: "#reviews", label: "Reviews" },
  { href: "#contact", label: "Book" },
];

const switchClass = ({ isActive }) =>
  `px-4 py-2 rounded-full text-[11px] font-bold uppercase tracking-wider flex items-center gap-2 transition-colors ${
    isActive ? "bg-white text-slate-950" : "text-slate-300 hover:text-white"
  }`;

export const SiteHeader = ({ brand }) => {
  const isZoryven = brand === "zoryven";
  const links = isZoryven ? ZORYVEN_LINKS : SALOON_LINKS;
  const accent = isZoryven ? "text-[#D48C46]" : "text-rose-400";
  const cta = isZoryven
    ? { href: "#range", label: "Explore Products", cls: "bg-[#D48C46] hover:bg-[#E5A862] text-slate-950" }
    : { href: "#contact", label: "Book Appointment", cls: "bg-rose-600 hover:bg-rose-500 text-white" };

  return (
    <header className={`sticky top-0 z-50 backdrop-blur border-b ${isZoryven ? "bg-[#06140E]/85 border-emerald-900/50" : "bg-slate-950/80 border-slate-800/80"}`} data-testid="site-header">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 h-20 flex items-center justify-between gap-2 sm:gap-4 overflow-hidden">
        <Link to={isZoryven ? "/" : "/saloon"} className="flex items-center gap-2 sm:gap-3 shrink-0" data-testid="brand-logo">
          <div className={`w-8 h-8 sm:w-9 sm:h-9 rounded-xl border flex items-center justify-center ${isZoryven ? "bg-emerald-500/10 border-emerald-500/30 text-emerald-300" : "bg-rose-500/10 border-rose-500/30 text-rose-400"}`}>
            {isZoryven ? <Leaf className="w-4 h-4" /> : <Scissors className="w-4 h-4" />}
          </div>
          <div className="leading-none">
            <div className="font-condensed text-base sm:text-xl tracking-tight uppercase text-white">{isZoryven ? "Zoryven" : "Fancy Saloon"}</div>
            <div className={`hidden sm:block text-[10px] uppercase tracking-[0.2em] ${accent}`}>{isZoryven ? "Hair Care" : "Unisex Salon"}</div>
          </div>
        </Link>

        <div className="flex items-center gap-2 sm:gap-3">
          <Link to="/#why-zoryven" data-testid="header-about-btn" className={`inline-flex whitespace-nowrap px-3 sm:px-4 py-2 text-[10px] sm:text-[11px] font-bold uppercase tracking-wider rounded-full border transition-colors ${isZoryven ? "border-[#D48C46]/50 text-[#E5A862] hover:bg-[#D48C46]/10" : "border-slate-700 text-slate-200 hover:bg-slate-800"}`}>
            About Us
          </Link>
          <div className="flex items-center gap-1 p-1 rounded-full bg-black/30 border border-white/10" data-testid="nav-brand-switch">
          <NavLink to="/" end className={switchClass} data-testid="nav-zoryven-home-link">
            <Leaf className="w-3.5 h-3.5" /> <span className="hidden sm:inline">Zoryven</span>
          </NavLink>
          <NavLink to="/saloon" className={switchClass} data-testid="nav-saloon-page-link">
            <Scissors className="w-3.5 h-3.5" /> <span className="hidden sm:inline">Fancy Saloon</span>
          </NavLink>
        </div>
        </div>

        <nav className="hidden lg:flex items-center gap-7 text-xs font-semibold uppercase tracking-wider text-slate-400" data-testid="main-nav">
          {links.map((l) => (
            <a key={l.href} href={l.href} className={`transition-colors ${isZoryven ? "hover:text-[#D48C46]" : "hover:text-rose-400"}`}>{l.label}</a>
          ))}
        </nav>

        <a href={cta.href} data-testid="header-cta-btn" className={`hidden md:inline-flex px-5 py-2.5 text-xs font-bold uppercase tracking-wider rounded-lg transition-colors ${cta.cls}`}>
          {cta.label}
        </a>
      </div>
    </header>
  );
};
